import { Button, Icon, Stack, Text } from '@chakra-ui/react';
import NiceModal from '@ebay/nice-modal-react';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineFileText } from 'react-icons/ai';
import { FiChevronDown } from 'react-icons/fi';
import { MdArrowDownward } from 'react-icons/md';

import AlertModal from '../components/modals/AlertModal';
import { fontWeights } from '../global/Fonts';
import { downloadFile } from '../helpers/downloadHelper';
import useFileQuery from '../hooks/useFileQuery';

type FileDeleteModalProps = {
  apiUrl: string;
  canEdit: boolean;
  handleReplace(): void;
  record: any;
  resourceKey: string;
  sendRequest?(x: object): void;
  isV2?: boolean;
};

const FileDisplay: FC<FileDeleteModalProps> = ({ canEdit, handleReplace, record, resourceKey, isV2 }) => {
  const { t } = useTranslation();
  const [url, setUrl] = useState('');
  const [click, setClick] = useState(false);

  const fileQuery = useFileQuery(url, isV2);

  const handleDownload = () => {
    setUrl(`${resourceKey}/${record?.id}/download`);
  };

  useEffect(() => {
    downloadFile(record?.file, fileQuery.data);
    setClick(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileQuery.data, click]);

  return (
    <Stack direction={'row'} alignItems={'center'} spacing={4}>
      <Stack direction={'row'} color="blue.500" spacing={2} alignItems={'center'}>
        <Icon as={AiOutlineFileText} boxSize="5" />
        <Text as="span" fontSize="md" fontWeight={fontWeights.bold}>
          {record.file.original_name}
        </Text>
      </Stack>
      <Button
        leftIcon={<MdArrowDownward />}
        variant="primary"
        size="sm"
        ml={2}
        data-test-id={`file-download-button`}
        onClick={() => {
          handleDownload();
          setClick(true);
        }}
      >
        {t('common:download')}
      </Button>
      <Button
        disabled={!canEdit}
        size="sm"
        onClick={() => {
          NiceModal.show(AlertModal as any, {
            onSubmit: handleReplace,
            redSubmitBttn: true,
            children: t('components:confirmation_card.modal.replace.warning'),
            content: {
              header: t('components:confirmation_card.modal.replace.header'),
              footer: {
                buttons: {
                  cancelCaption: t('common:cancel'),
                  actionCaption: t('common:replace'),
                },
              },
            },
          });
        }}
        colorScheme="red"
        // variant={'outline'}
        data-test-id="file-delete"
      >
        <Icon as={FiChevronDown} boxSize="4" />
        {t('common:replace')}
      </Button>
    </Stack>
  );
};

export default FileDisplay;
